module.exports = __webpack_public_path__ + "static/media/12.3d72a06a.png";